import { render, staticRenderFns } from "./historyMonitor.vue?vue&type=template&id=2ae05f8e&scoped=true"
import script from "./historyMonitor.vue?vue&type=script&lang=js"
export * from "./historyMonitor.vue?vue&type=script&lang=js"
import style0 from "./historyMonitor.vue?vue&type=style&index=0&id=2ae05f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae05f8e",
  null
  
)

export default component.exports